import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/InfluencerCampaignList.graphql';
import { Query, QueryinfluencerCampaignListArgs } from '../../__generated__/globalTypes';

export const useInfluencerCampaignListQuery = (options?: QueryHookOptions<Query, QueryinfluencerCampaignListArgs>) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryinfluencerCampaignListArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useInfluencerCampaignListLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryinfluencerCampaignListArgs>
): QueryResult<Query, QueryinfluencerCampaignListArgs> & {
  getInfluencerCampaignList: LazyQueryExecFunction<Query, QueryinfluencerCampaignListArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getInfluencerCampaignList, result] = useLazyQuery<Query, QueryinfluencerCampaignListArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getInfluencerCampaignList, ...result };
};

export const useInfluencerCampaignListPromiseQuery = () => {
  const client = useApolloClient();

  const getInfluencerCampaignList = useCallback(
    (options?: Omit<QueryOptions<QueryinfluencerCampaignListArgs, Query>, 'query'>) =>
      client.query<Query, QueryinfluencerCampaignListArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getInfluencerCampaignList };
};
// Suspense Query Hooks
export const useInfluencerCampaignListSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryinfluencerCampaignListArgs>
) => {
  const result = useSuspenseQuery<Query, QueryinfluencerCampaignListArgs>(QUERY, {
    ...options
  });

  return result;
};
